<template>
    <div class="flex justify-between">
        <div class="relative flex items-center" :class="full ? 'w-full' : 'w-7/12 sm:w-2/3'">

            <input ref="input" type="text" v-on:keyup.enter="searchEnter()" maxlength="40" v-model="search" :placeholder="placeholder" class=" h-[38px] pl-10 shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full pr-24 sm:text-sm text-gray-600 font-light border-white rounded-md" />            

            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MagnifyingGlassIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
            </div>

            <div v-if="search && search?.length > 0" class="invisible sm:visible absolute flex inset-y-0 right-0 py-1.5 pr-1.5">                
                <router-link :to="resetRoute()" class="pt-1.5" @click="resetSearch()" >
                    <XMarkIcon class="w-4 h-4"/>
                </router-link>

                <div @click="searchEnter()" class="cursor-pointer pt-1 inline-flex items-center border border-white rounded px-2 text-xs font-sans text-gray-400 font-light uppercase">
                    Buscar
                </div>
            </div>
        </div>

        <div class="flex justify-end items-center"> 
            <slot/>
        </div>
    </div>
</template>

<script>

import { XMarkIcon, MagnifyingGlassIcon, } from '@heroicons/vue/24/solid';

export default {
    name: "SearchFild",
    props: {
        value: {
            type: String,
            required: false,
        },
        placeholder: String,
        onSearch: Function,
        full: Boolean,
    },
    data(){
        return {
            search: this.value || '',
        }
    },
    methods: {
        focus() {
            this.$refs.input?.focus();
        },

        resetRoute() {                  
            return this.$route.path;
        },

        searchEnter() {
            if (this.onSearch) {
                this.onSearch(this.search);
            } else {
                this.$router.push({
                    path: this.$route.path,
                    query: {
                        page: 1,
                        search: this.search,
                    }
                });
            }
        },

        resetSearch() {
            this.search = '';
        },
    },

    watch: {
        $route(newValue){
            this.search = newValue.query.search || '';
        },

        value(newValue){
            this.search = newValue;
        }

    },


    components: {
        MagnifyingGlassIcon,
        XMarkIcon,
    },
}
</script>
